import * as Api from "@modules/api";
import { db } from "@modules/local/db";
import { store } from "../../stores";
import { getStorage, setStorage } from "@modules/storage/storageHelper";
import { getIsB2bData } from "@modules/content/B2BContext";
import { errorHandler } from "@utils/helpers/errorHandler";

export const getReaderFlowAsync = async (): Promise<
  Api.Server.FlowOutput2 | undefined
> => {
  return errorHandler(async () => {
    const client = new Api.Server.Server_Flows_Client(undefined, Api.apiClient);

    const response = await client.flows_reader_get_V2();

    if (response.success && response.data) {
      if (response.data.isB2B) {
        const client = new Api.Server.Server_BusinessGroup_Client(
          undefined,
          Api.apiClient
        );

        const localB2B = await getStorage("B2B");

        const b2bResponse = await client.businessGroup_myBusinessGroup_get_V1();

        if (b2bResponse.success && b2bResponse.data) {
          await setStorage({
            key: "B2B",
            data: getIsB2bData(
              {
                userId: store.getState().auth.user.id ?? "",
                ...response.data,
              },
              localB2B?.isB2B,
              [b2bResponse.data]
            ),
          });
        }
      } else {
        await setStorage({
          key: "B2B",
          data: {
            isB2B: false,
            data: [],
            isB2bAllowed: !!response.data.tabs?.find((tab) => tab.isB2B),
            isB2cAllowed: !!response.data.tabs?.find(
              (tab) => !tab.isB2B && !tab.isCarPlay
            ),
          },
        });
      }

      await db.readerFlows.put({
        ...response.data,
        userId: store.getState().auth.user.id ?? "",
      });

      return response.data;
    }

    if (response.success && !response.data) {
      throw new Error("No Data");
    }

    throw response.errors;
  });
};

export const FlowsActions = {
  getReaderFlowAsync,
};
